export const urls = {
  auth: process.env.REACT_APP_AUTH_SERVICE,
  baseUrl: process.env.REACT_APP_AUX_CLINIC,
  usersBaseUrl: process.env.REACT_APP_USER_SERVICE,
};
